import '../Main.scss';

import * as React from 'react';
import { connect } from 'react-redux';

import {
    Button,
    Col,
    Container,
    Row
} from 'reactstrap';

import { ApplicationState } from '../../Store';

import { AccountingPkgPresentation } from './AccountingPkgPresentation';

import { PortalTextImportModals } from '../../Models/Api/strongbox.financialportal';
import { GetPortalText } from '../../Store/PortalAssets';

type InjectedReduxState = {
    supplementalParagraphs: React.ReactElement[];
}

type InjectedActionCreators = {

}

type AccountingSystemGroupProps = {
    id: string;
    name?: string;
    accountingSystems: AccountingPkgPresentation[];
    disabled?: boolean;
    tabIndexBase: number;
    immediateConnectPkg?: AccountingPkgPresentation;
};

type Props = AccountingSystemGroupProps & InjectedActionCreators & InjectedReduxState;

const AccountingSystemGroupComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        accountingSystems,
        disabled,
        id,
        supplementalParagraphs,
        tabIndexBase,
        immediateConnectPkg,
    } = props;

    const idImmediateConnectButton = 'immediate-connect-button';

    const [executeImmediate, setExecuteImmediate] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (executeImmediate) {
            const button = document.getElementById(idImmediateConnectButton);
            if (button != null) {
                button.click();
            }
            setExecuteImmediate(false);
        }
    }, [executeImmediate])

    React.useEffect(() => {
        if (!!immediateConnectPkg) {
            setExecuteImmediate(true);
        }
    }, [immediateConnectPkg]);

    return (
        <Container className={'button-group-container'} key={`accountingSystemGroup${id}`}>
            {!!immediateConnectPkg && (
                <Row>
                    <Col>
                        <Button
                            onClick={() => {
                                // true suppresses the creation of a submission
                                immediateConnectPkg.onPkgSelected(immediateConnectPkg, true);
                            }}
                            key={'accounting-selection-button-1'}
                            id={idImmediateConnectButton}
                            tabIndex={0}
                            style={{
                                visibility: 'hidden',
                            }}
                        >
                            {immediateConnectPkg.friendlyName}
                        </Button>
                    </Col>
                </Row>
            )}
            {!immediateConnectPkg && (
                <Row>
                    <Col>
                        {
                            accountingSystems.map((pkg, pkgIndex) => {
                                let pkgClass = !!disabled ? 'disabled' : '';
                                return (
                                    <Row
                                        key={`accounting-selection-button-row-${pkg.friendlyName}`}
                                    >
                                        <Col
                                            key={`accounting-selection-button-col-${pkg.friendlyName}`}
                                        >
                                            <Button
                                                className={pkgClass}
                                                onClick={() => pkg.onPkgSelected(pkg)}
                                                key={`accounting-selection-button-${pkg.friendlyName}`}
                                                tabIndex={tabIndexBase + pkgIndex}
                                            >
                                                {pkg.friendlyName}{pkg.isBeta && (<sup>&nbsp;Beta</sup>)}
                                            </Button>
                                        </Col>
                                    </Row>
                                );
                            })
                        }
                    </Col>
                </Row>
            )}
            {!!supplementalParagraphs && !immediateConnectPkg && (
                <Row className={'supplemental-row extra-row-spacing-medium'}>
                    <Col>
                        {
                            supplementalParagraphs.map((p, i) => {
                                return (
                                    <p
                                        className={'supplemental'}
                                        key={`select-accounting-system-supplemental-${i}`}
                                    >
                                        {p}
                                    </p>
                                )
                            })
                        }
                    </Col>
                </Row>
            )}
        </Container>
    );
}

export const AccountingSystemGroup = connect<InjectedReduxState, InjectedActionCreators, AccountingSystemGroupProps, ApplicationState>(
    (appState: ApplicationState, props: AccountingSystemGroupProps) => {
        const importModalText = GetPortalText<PortalTextImportModals>(appState, 'importModals');
        const supplementalParagraphs: React.ReactElement[] = [];

        if (!!importModalText) {
            importModalText.selectAccountingSystemSupplemental.forEach((p, pi) => supplementalParagraphs.push((<span key={`select-accounting-system-supplemental-${pi}`}>{p}</span>)));
        }

        const result = {
            supplementalParagraphs,
        };

        return result;
    }
)(AccountingSystemGroupComponent);
